class AnimatedNumber extends HTMLElement {
  constructor(colorsMap, callback, initNumber) {
    super(callback, initNumber);

    this.count = 100;
    this.COLORS = colorsMap || {
      0: "#F3F3F3",
      3: "#FF8B50",
      6: "#24AE87",
      9: "#87CAD7",
    };

    this.renderedNumber;

    this.container = document.createElement("div");
    this.container.classList.add("number");

    const init = this.init;
    const animate = this.animate;

    const scripts = [
      "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/gsap.min.js",
      "https://d3js.org/d3.v7.min.js",
    ];

    const loadScript = (url) => {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.src = url;
        script.async = false;
        script.onload = () => {
          resolve(url);
        };
        script.onerror = () => {
          reject(url);
        };
        document.head.appendChild(script);
      });
    };

    // save all Promises as array
    let promises = [];
    scripts.forEach((url) => {
      promises.push(loadScript(url));
    });

    Promise.all(promises)
      .then(() => {
        callback();
      })
      .catch((script) => {
        console.log(script + " failed to load");
      });
  }

  init(number) {
    const svg = `<svg viewBox="0 0 300 300" class="svg">
    <defs>
      <filter id="gooey">
        <feGaussianBlur
          in="SourceGraphic"
          :stdDeviation="gooey"
          result="blur"
        />
        <feColorMatrix
          in="blur"
          mode="matrix"
          values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -14"
          result="filter"
        />
        <feComposite in="SourceGraphic" in2="filter" operator="atop" />
      </filter>
      <filter id="outline">
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius="1"
          result="OUTLINE"
        />
        <feComposite operator="out" in="OUTLINE" in2="SourceAlpha" />
      </filter>
    </defs>
    <g ref="paths" class="paths"></g>
      <g class="gooey" class="active" id='circles' />
  </svg>`;
    this.container.innerHTML = svg;
    const paths = this.container.querySelector(".paths");
    paths.innerHTML = this.numbersHTML();

    const circles = this.container.querySelector("#circles");
    const namespace = "http://www.w3.org/2000/svg";

    for (let i = 0; i < this.count; i++) {
      const circle = document.createElementNS(namespace, "circle");
      circle.classList.add("circle");
      circle.setAttribute("r", 55);
      circle.setAttribute("cx", 128);
      circle.setAttribute("cy", 128);
      circle.setAttribute("fill", this.COLORS[number]);
      circles.appendChild(circle);
    }

    return this.container;
  }

  numbersHTML() {
    const paths = `<path d="M204.1 153.2C204.1 178.7 201.9 198.8 191.6 213.5C181.3 228.2 167.5 235.5 149.9 235.5C132.4 235.5 118.5 228.2 108.4 213.5C98.3 198.8 96.2 178.7 96.2 153.2V146.6C96.2 121.1 98.3 100.9 108.4 86.2C118.6 71.4 132.4 64 150 64C167.5 64 181.4 71.4 191.7 86.1C202 100.9 204.1 121 204.1 146.5V153.2Z" />
        <path d="M109.9 101.2C111 100.8 163.6 61.9998 164.8 62.0998V242.6" />
        <path d="M103.7 107.7C102.3 40.6998 216 52.5998 193.9 119.3C181.3 151.3 123.3 203 105.1 233H210.9" />
        <path d="M96.8 200.5C99.8 239.9 160.7 247.2 185.4 224.2C219.7 189.1 190.8 148.4 143.7 147.2C173.6 152.7 212.4 104.1 180.2 73.5C156.8 52 103.7 62.4 101.6 98.5" />
        <path d="M183.9 242.8V63L94.5999 192.9H230.2" />
        <path d="M205.2 65.6997H114.1L104.1 154C104.1 154 122.4 132.1 155.1 132.1C187.8 132.1 204.5 164.7 204.5 180.3C204.5 202.5 195 237.3 152 237.3C109 237.3 100.6 200.6 100.6 200.6" />
        <path d="M111.797 143.394C122.318 134.492 135.822 129.907 149.588 130.562C163.355 131.216 176.362 137.062 185.991 146.922C195.62 156.782 201.156 169.924 201.484 183.702C201.813 197.48 196.909 210.871 187.76 221.178C178.611 231.486 165.897 237.944 152.177 239.254C138.458 240.563 124.751 236.626 113.818 228.235C102.885 219.844 95.5369 207.622 93.2532 194.031C90.9696 180.439 93.92 166.487 101.51 154.984L164 63.5" />
        <path d="M95.3 65.6997H199.7L119.9 242.6" />
        <path d="M148.8 144.8C148.8 144.8 197 143.5 197 102.6C197 61.6999 148.8 62.6999 148.8 62.6999C148.8 62.6999 102.9 62.6999 102.9 103.6C102.9 124.1 121.7 144.8 149.8 144.8C179.4 144.8 204.7 162.8 204.7 192C204.7 192 206.7 236.9 150.5 236.9C95 236.9 96.3 193 96.3 193C96.3 193 96 145.1 149.9 145.1" />
        <path d="M188.203 156.605C177.681 165.508 164.178 170.093 150.412 169.438C136.645 168.784 123.638 162.938 114.009 153.078C104.38 143.218 98.8437 130.076 98.5155 116.298C98.1873 102.52 103.091 89.1289 112.24 78.8215C121.389 68.5141 134.103 62.0556 147.823 60.7464C161.542 59.4371 175.248 63.3743 186.182 71.7653C197.115 80.1562 204.463 92.3778 206.747 105.969C209.03 119.561 206.08 133.513 198.489 145.016L136 236.5" />`;

    return paths;
  }

  animate(n) {
    if (this.renderedNumber != n) {
      const gsap = window.gsap;
      const scaleLinear = window.d3.scaleLinear;
      const colorFunc = window.d3.color;
      let paths = Array.from(this.container.querySelectorAll("path"));
      let circles = this.container.querySelectorAll(".circle");

      if (!paths[n]) return;

      const length = paths[n].getTotalLength();
      const step = length / this.count;
      for (let i = 0; i < this.count; i++) {
        const { x, y } = paths[n].getPointAtLength(i * step);
        let fill = "#FF8B50";

        let color1 = this.COLORS[n] || fill;
        let color2 = colorFunc(color1).darker(0.6);

        let range = [color2, color1];

        const gradient = scaleLinear().domain([0, this.count]).range(range);
        fill = gradient(i);

        gsap.to(circles[i], {
          ease: "power3.out",
          duration: 0.75,
          attr: {
            cx: x,
            cy: y,
            fill: fill,
            stroke: "transparent",
          },
          delay: i * 0.0024,
        });
      }
      this.renderedNumber = n;
    }
  }
}

if (!customElements.get("animated-number")) {
  customElements.define("animated-number", AnimatedNumber);
}
